import { MutableRefObject } from 'react';
import jsPDF from 'jspdf';
import { round } from '@oliasoft-open-source/units';
import { HOURS_PER_DAY } from 'src/enums/general';
import { shownCumulativeProbabilities } from 'views/simulations/simulations';
import { addChart } from 'views/report/utils/add-chart/add-chart.ts';
import { addTable } from 'views/report/utils/add-table/add-table.ts';
import { lineInterval } from 'views/report/utils/style-consts.ts';
import { addTitle } from 'views/report/utils/add-title/add-title.ts';

export const addCumulativeProbabilityTimePage = async (
  doc: jsPDF,
  padding: number,
  forecastLogoHeight: number,
  chartRef: MutableRefObject<null>,
  simulationsResult: any,
) => {
  doc.addPage();

  addTitle(doc, 'Cumulative Probability (Time)', {
    x: padding,
    y: forecastLogoHeight + padding + lineInterval,
  });

  const chart = await addChart(doc, chartRef);

  const { probabilities, time } = simulationsResult?.cumulative_probability || {};
  const tableDataTime =
    time
      ?.map((time: number) => round(time / HOURS_PER_DAY, 2))
      ?.filter((_: number, index: number) => shownCumulativeProbabilities.includes(index)) || [];
  const tableDataRisk =
    simulationsResult?.cumulative_subactivity_percentiles
      ?.filter((_: number, index: number) => shownCumulativeProbabilities.includes(index))
      ?.map((el: number) => round(el / 24, 2)) || [];

  const tableStartY = padding + forecastLogoHeight + chart.chartHeight + 2 * lineInterval;

  const rows = [
    ['', ...shownCumulativeProbabilities].map((probability) => ({
      content: probabilities?.[probability] ?? '',
      styles: { fontStyle: 'bold' },
    })),
    ['', ...shownCumulativeProbabilities].map((_, idx) => ({
      content: idx ? 'Days' : '',
      styles: { fontStyle: 'italic' },
    })),
    [{ content: 'Estimated time', styles: { fontStyle: 'bold' } }, ...tableDataTime],
    [{ content: 'Risk only', styles: { fontStyle: 'bold' } }, ...tableDataRisk],
  ];

  addTable(doc, rows, { y: tableStartY });
};
